var _mask, _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHover2Buttons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 58,
    viewBox: "0 0 94 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_8222_36602",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H42.8976L47.331 58L51.7644 48H84C89.5229 48 94 43.5229 94 38V10C94 4.47715 89.5229 0 84 0H10Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H42.8976L47.331 58L51.7644 48H84C89.5229 48 94 43.5229 94 38V10C94 4.47715 89.5229 0 84 0H10Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8976 48L43.8118 47.5947L43.5481 47H42.8976V48ZM47.331 58L46.4168 58.4053L47.331 60.4673L48.2452 58.4053L47.331 58ZM51.7644 48V47H51.1139L50.8502 47.5947L51.7644 48ZM1 10C1 5.02944 5.02944 1 10 1V-1C3.92487 -1 -1 3.92487 -1 10H1ZM1 38V10H-1V38H1ZM10 47C5.02944 47 1 42.9706 1 38H-1C-1 44.0751 3.92487 49 10 49V47ZM42.8976 47H10V49H42.8976V47ZM48.2452 57.5947L43.8118 47.5947L41.9834 48.4053L46.4168 58.4053L48.2452 57.5947ZM50.8502 47.5947L46.4168 57.5947L48.2452 58.4053L52.6786 48.4053L50.8502 47.5947ZM84 47H51.7644V49H84V47ZM93 38C93 42.9706 88.9706 47 84 47V49C90.0751 49 95 44.0751 95 38H93ZM93 10V38H95V10H93ZM84 1C88.9706 1 93 5.02944 93 10H95C95 3.92487 90.0751 -1 84 -1V1ZM10 1H84V-1H10V1Z",
    fill: "#003E6B",
    mask: "url(#path-1-inside-1_8222_36602)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    width: 1,
    height: 48,
    fill: "#003E6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHover2Buttons);
export default __webpack_public_path__ + "static/media/Hover2Buttons.e696e72451b19367884c9b80ac510166.svg";
export { ForwardRef as ReactComponent };